import { render, staticRenderFns } from "./TermPopup2.vue?vue&type=template&id=02d85bdf&"
import script from "./TermPopup2.vue?vue&type=script&lang=js&"
export * from "./TermPopup2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports